
import React, { useState } from "react";
import { Menu, MenuItem, Button } from "@mui/material";
import {  MenuButton} from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/20/solid'

function DateRangePickerComponent({ onDateSelected }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedLabel, setSelectedLabel] = useState("Today");
  const [selectedRange, setSelectedRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });

  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const setPredefinedRange = (type) => {
    let startDate, endDate;
    const today = new Date();
    let label = "Date Range";

    switch (type) {
      case "today":
        startDate = resetTime(new Date());
        endDate = startDate;
        label = "Today";
        break;
      case "yesterday":
        startDate = resetTime(new Date());
        startDate.setDate(startDate.getDate() - 1);
        endDate = startDate;
        label = "Yesterday";
        break;
      case "thisWeek":
        startDate = new Date(today);
        startDate.setDate(today.getDate() - today.getDay());
        endDate = today;
        label = "This Week";
        break;
      case "lastWeek":
        startDate = new Date(today);
        startDate.setDate(today.getDate() - today.getDay() - 7);
        endDate = new Date(startDate);
        endDate.setDate(endDate.getDate() + 6);
        label = "Last Week";
        break;
      case "thisMonth":
        startDate = new Date(today.getFullYear(), today.getMonth(), 1);
        endDate = today;
        label = "This Month";
        break;
      case "lastMonth":
        startDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        endDate = new Date(today.getFullYear(), today.getMonth(), 0);
        label = "Last Month";
        break;
      case "last7Days":
        startDate = new Date(today);
        startDate.setDate(today.getDate() - 7);
        endDate = today;
        label = "Last 7 Days";
        break;
      case "last30Days":
        startDate = new Date(today);
        startDate.setDate(today.getDate() - 30);
        endDate = today;
        label = "Last 30 Days";
        break;
      default:
        return;
    }

    setSelectedRange({ startDate, endDate, key: "selection" });
    setSelectedLabel(label);
    onDateSelected(startDate, endDate);
    handleClose();
     // Close menu after selection
  };

  const resetTime = (date) => {
    return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  };

  return (
    <div>
      <Button
        onClick={handleClick}
        variant="outlined"
         sx={{ textTransform: "none", borderColor: "#cbd5e0;", color: "black" , background:"white" }}
        className="border text-gray-900 border-black w-36  bg-white hover:bg-gray-50 text-sm font-semibold"
      >
        {selectedLabel}
        <ChevronDownIcon aria-hidden="true" className="-mr-1 size-5  text-gray-400 bg-white" />
      </Button>
   
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem onClick={() => setPredefinedRange("today")} >Today </MenuItem>
        <MenuItem onClick={() => setPredefinedRange("yesterday")}>Yesterday</MenuItem>
        <MenuItem onClick={() => setPredefinedRange("thisWeek")}>This Week</MenuItem>
        <MenuItem onClick={() => setPredefinedRange("lastWeek")}>Last Week</MenuItem>
        <MenuItem onClick={() => setPredefinedRange("thisMonth")}>This Month</MenuItem>
        <MenuItem onClick={() => setPredefinedRange("lastMonth")}>Last Month</MenuItem>
        <MenuItem onClick={() => setPredefinedRange("last7Days")}>Last 7 Days</MenuItem>
        <MenuItem onClick={() => setPredefinedRange("last30Days")}>Last 30 Days</MenuItem>
      </Menu>
    </div>
  );
}

export default DateRangePickerComponent;


